


function reinitializeMasonry(){
  var $container = $('#portfolioFeed');
  $container.imagesLoaded( function(){
    $container.masonry({
      itemSelector : '#portfolioFeed div',
      isAnimated: true, 
    });
  });
}


/*http://codepen.io/nattkua/pen/KsheI*/
var in_url = "https://api.instagram.com/v1/users/2864842009/media/recent?client_id=d33e1e91d853442dac75a8cd25fef5d0&count=9";
//https://www.instagram.com/finkavenue/media/?max_id=13658761_299306840459712_913806030
//ee416d9940f54387bc42980fac0108eb
//https://www.instagram.com/oauth/authorize/?client_id=d1adc6c6f4e24c5bb990887b1d30e6b3&redirect_uri=http://www.finkavenue.com&response_type=code
var tm_url = "https://api.pinterest.com/v1/boards/finkavenue/trademark-portfolio/pins/?access_token=AcrCmdf8IcKwXQw9VUf6SZeaUue4FDowCuCpsdxC7QVKEKArWwAAAAA&fields=id,url,image,note,created_at,counts,creator,note&limit=40";
var co_url = "https://api.pinterest.com/v1/boards/finkavenue/website-portfolio/pins/?access_token=AcrCmdf8IcKwXQw9VUf6SZeaUue4FDowCuCpsdxC7QVKEKArWwAAAAA&fields=id,url,image,note,created_at,counts,creator,note&limit=40";
var pi_url = "https://api.pinterest.com/v1/boards/voguemagazine/best-dressed-celebrity-fashion/pins/?access_token=AcrCmdf8IcKwXQw9VUf6SZeaUue4FDowCuCpsdxC7QVKEKArWwAAAAA&fields=id,url,image,note,created_at,counts,creator,note&limit=40";
var tu_url = "https://api.tumblr.com/v2/blog/finkavenue.tumblr.com/posts?api_key=J9laYIsNjFcaitQTgjP6fMKP0g4w1AKWoUIR41nTQm8lIzJK2x";


instagram(in_url);
pinterest(pi_url);
pinterest_tm(tm_url);
pinterest_co(co_url);
tumblr(tu_url);


function instagram(url) {
  $.ajax({
    type: "GET",
    dataType: "jsonp",
    cache: false,
    url: url,
    success: function(data) 
    {                             

      for(var i=0;i<1; i++)
      {
        // $("#instagram").append('<span><a href="'+data.data[0].link+'" class="col-lg-4 col-md-3 col-sm-4 col-xs-4 text-center" style="background-image: url('+data.data[0].images.standard_resolution.url+');" class="col-lg-4 col-md-3 col-sm-4 col-xs-4 text-center" style="background-image: url('+data.data[0].images.standard_resolution.url+');"></a><a href="'+data.data[1].link+'" class="col-lg-4 col-md-3 col-sm-4 col-xs-4 text-center" style="background-image: url('+data.data[1].images.standard_resolution.url+');"></a><a href="'+data.data[2].link+'" class="col-lg-4 col-md-3 col-sm-4 col-xs-4 text-center" style="background-image: url('+data.data[2].images.standard_resolution.url+');"></a></span><span><a href="'+data.data[3].link+'" class="col-lg-4 col-md-3 col-sm-4 col-xs-4 text-center" style="background-image: url('+data.data[3].images.standard_resolution.url+');"></a><a href="'+data.data[4].link+'" class="col-lg-4 col-md-3 col-sm-4 col-xs-4 text-center" style="background-image: url('+data.data[4].images.standard_resolution.url+');"></a><a href="'+data.data[5].link+'" class="col-lg-4 col-md-3 col-sm-4 col-xs-4 text-center" style="background-image: url('+data.data[5].images.standard_resolution.url+');"></a></span><span><a href="'+data.data[6].link+'" class="col-lg-3 col-md-3 col-sm-3 col-xs-3 text-center" style="background-image: url('+data.data[6].images.standard_resolution.url+');"></a><a href="'+data.data[7].link+'" class="col-lg-3 col-md-3 col-sm-3 col-xs-3 text-center" style="background-image: url('+data.data[7].images.standard_resolution.url+');"></a><a href="'+data.data[8].link+'" class="col-lg-3 col-md-3 col-sm-3 col-xs-3 text-center" style="background-image: url('+data.data[8].images.standard_resolution.url+');"></a></span>');
        // $("#portfolioFeed").append('<a href="'+data.data[0].link+'" class="col-lg-4 col-md-3 col-sm-4 col-xs-4 text-center" style="background-image: url('+data.data[0].images.standard_resolution.url+');" class="col-lg-4 col-md-3 col-sm-4 col-xs-4 text-center" style="background-image: url('+data.data[0].images.standard_resolution.url+');"></a><a href="'+data.data[1].link+'" class="col-lg-4 col-md-3 col-sm-4 col-xs-4 text-center" style="background-image: url('+data.data[1].images.standard_resolution.url+');"></a><a href="'+data.data[2].link+'" class="col-lg-4 col-md-3 col-sm-4 col-xs-4 text-center" style="background-image: url('+data.data[2].images.standard_resolution.url+');"></a><a href="'+data.data[3].link+'" class="col-lg-4 col-md-3 col-sm-4 col-xs-4 text-center" style="background-image: url('+data.data[3].images.standard_resolution.url+');"></a><a href="'+data.data[4].link+'" class="col-lg-4 col-md-3 col-sm-4 col-xs-4 text-center" style="background-image: url('+data.data[4].images.standard_resolution.url+');"></a><a href="'+data.data[5].link+'" class="col-lg-4 col-md-3 col-sm-4 col-xs-4 text-center" style="background-image: url('+data.data[5].images.standard_resolution.url+');"></a><a href="'+data.data[6].link+'" class="col-lg-3 col-md-3 col-sm-3 col-xs-3 text-center" style="background-image: url('+data.data[6].images.standard_resolution.url+');"></a><a href="'+data.data[7].link+'" class="col-lg-3 col-md-3 col-sm-3 col-xs-3 text-center" style="background-image: url('+data.data[7].images.standard_resolution.url+');"></a><a href="'+data.data[8].link+'" class="col-lg-3 col-md-3 col-sm-3 col-xs-3 text-center" style="background-image: url('+data.data[8].images.standard_resolution.url+');"></a>');

        $("#instagram_1").append(' <a href="'+data.data[0].link+'" ><article><img src="'+data.data[0].images.standard_resolution.url+'" /></article></a>');               
        $("#instagram_2").append(' <a href="'+data.data[1].link+'" ><article><img src="'+data.data[1].images.standard_resolution.url+'" /></article></a>');               
        $("#instagram_3").append(' <a href="'+data.data[2].link+'" ><article><img src="'+data.data[2].images.standard_resolution.url+'" /></article></a>');               
        $("#instagram_4").append(' <a href="'+data.data[3].link+'" ><article><img src="'+data.data[3].images.standard_resolution.url+'" /></article></a>');               
        $("#instagram_5").append(' <a href="'+data.data[4].link+'" ><article><img src="'+data.data[4].images.standard_resolution.url+'" /></article></a>');               
        $("#instagram_6").append(' <a href="'+data.data[5].link+'" ><article><img src="'+data.data[5].images.standard_resolution.url+'" /></article></a>');               
        $("#instagram_7").append(' <a href="'+data.data[6].link+'" ><article><img src="'+data.data[6].images.standard_resolution.url+'" /></article></a>');               
        $("#instagram_8").append(' <a href="'+data.data[7].link+'" ><article><img src="'+data.data[7].images.standard_resolution.url+'" /></article></a>');               
        $("#instagram_9").append(' <a href="'+data.data[8].link+'" ><article><img src="'+data.data[8].images.standard_resolution.url+'" /></article></a>');               
        $("#instagram_10").append(' <a href="'+data.data[9].link+'" ><article><img src="'+data.data[9].images.standard_resolution.url+'" /></article></a>');               

        reinitializeMasonry();

        $("#footerFeatures").append('<div class="col-lg-6 col-md-6 col-sm-6 col-xs-12"><a href="'+data.data[0].link+'" class="col-lg-3 col-md-3 col-sm-3 col-xs-3 text-center" style="background-image: url('+data.data[0].images.standard_resolution.url+');"></a><a href="'+data.data[1].link+'" class="col-lg-3 col-md-3 col-sm-3 col-xs-3 text-center" style="background-image: url('+data.data[1].images.standard_resolution.url+');"></a><a href="'+data.data[2].link+'" class="col-lg-3 col-md-3 col-sm-3 col-xs-3 text-center" style="background-image: url('+data.data[2].images.standard_resolution.url+');"></a><a href="'+data.data[3].link+'" class="col-lg-3 col-md-3 col-sm-3 col-xs-3 text-center" style="background-image: url('+data.data[3].images.standard_resolution.url+');"></a></div><div class="col-lg-6 col-md-6 col-sm-6 col-xs-12"><a href="'+data.data[4].link+'" class="col-lg-3 col-md-3 col-sm-3 col-xs-3 text-center" style="background-image: url('+data.data[4].images.standard_resolution.url+');"></a><a href="'+data.data[5].link+'" class="col-lg-4 col-md-3 col-sm-4 col-xs-3 text-center" style="background-image: url('+data.data[5].images.standard_resolution.url+');"></a><a href="'+data.data[6].link+'" class="col-lg-4 col-md-3 col-sm-4 col-xs-4 text-center" style="background-image: url('+data.data[6].images.standard_resolution.url+');"></a><a href="'+data.data[7].link+'" class="col-lg-4 col-md-3 col-sm-4 col-xs-4 text-center" style="background-image: url('+data.data[7].images.standard_resolution.url+');"></a>'); 
      }
    }
  });
}
function pinterest(url) {
  $.ajax({
    type: "GET",
    dataType: "jsonp",
    cache: false,
    url: url,
    success: function(data) 
    {                             

      console.log(data);/*Object.keys(data).length/3*/
      for(var i=0;i<1; i++)
      {        
        $("#pinterest_1").append(' <a href="'+data.data[0].url+'" class="articleOne text-center" style=""><article><img src="'+data.data[0].image.original.url+'" /></article></a>');               
        $("#pinterest_2").append(' <a href="'+data.data[1].url+'" class="articleOne text-center" style=""><article><img src="'+data.data[1].image.original.url+'" /></article></a>');               
        $("#pinterest_3").append(' <a href="'+data.data[2].url+'" class="articleOne text-center" style=""><article><img src="'+data.data[2].image.original.url+'" /></article></a>');               
        $("#pinterest_4").append(' <a href="'+data.data[3].url+'" class="articleOne text-center" style=""><article><img src="'+data.data[3].image.original.url+'" /></article></a>');               
        $("#pinterest_5").append(' <a href="'+data.data[4].url+'" class="articleOne text-center" style=""><article><img src="'+data.data[4].image.original.url+'" /></article></a>');               
        $("#pinterest_6").append(' <a href="'+data.data[5].url+'" class="articleOne text-center" style=""><article><img src="'+data.data[5].image.original.url+'" /></article></a>');               
        $("#pinterest_7").append(' <a href="'+data.data[6].url+'" class="articleOne text-center" style=""><article><img src="'+data.data[6].image.original.url+'" /></article></a>');               
        $("#pinterest_8").append(' <a href="'+data.data[7].url+'" class="articleOne text-center" style=""><article><img src="'+data.data[7].image.original.url+'" /></article></a>');               
        $("#pinterest_9").append(' <a href="'+data.data[8].url+'" class="articleOne text-center" style=""><article><img src="'+data.data[8].image.original.url+'" /></article></a>');               
        $("#pinterest_10").append(' <a href="'+data.data[9].url+'" class="articleOne text-center" style=""><article><img src="'+data.data[9].image.original.url+'" /></article></a>');               
        /*$("#pinterest_11").append(' <a href="'+data.data[10].url+'" class="articleOne text-center" style=""><article><img src="'+data.data[10].image.original.url+'" /></article></a>');               
        $("#pinterest_12").append(' <a href="'+data.data[11].url+'" class="articleOne text-center" style=""><article><img src="'+data.data[11].image.original.url+'" /></article></a>');               
        $("#pinterest_13").append(' <a href="'+data.data[12].url+'" class="articleOne text-center" style=""><article><img src="'+data.data[12].image.original.url+'" /></article></a>');               
        $("#pinterest_14").append(' <a href="'+data.data[13].url+'" class="articleOne text-center" style=""><article><img src="'+data.data[13].image.original.url+'" /></article></a>');               
        $("#pinterest_15").append(' <a href="'+data.data[14].url+'" class="articleOne text-center" style=""><article><img src="'+data.data[14].image.original.url+'" /></article></a>');               
        $("#pinterest_16").append(' <a href="'+data.data[15].url+'" class="articleOne text-center" style=""><article><img src="'+data.data[15].image.original.url+'" /></article></a>');               
        $("#pinterest_17").append(' <a href="'+data.data[16].url+'" class="articleOne text-center" style=""><article><img src="'+data.data[16].image.original.url+'" /></article></a>');               
        $("#pinterest_18").append(' <a href="'+data.data[17].url+'" class="articleOne text-center" style=""><article><img src="'+data.data[17].image.original.url+'" /></article></a>');               
        $("#pinterest_19").append(' <a href="'+data.data[18].url+'" class="articleOne text-center" style=""><article><img src="'+data.data[18].image.original.url+'" /></article></a>');               
        $("#pinterest_20").append(' <a href="'+data.data[19].url+'" class="articleOne text-center" style=""><article><img src="'+data.data[19].image.original.url+'" /></article></a>');               
        $("#pinterest_21").append(' <a href="'+data.data[20].url+'" class="articleOne text-center" style=""><article><img src="'+data.data[20].image.original.url+'" /></article></a>');               
        $("#pinterest_22").append(' <a href="'+data.data[21].url+'" class="articleOne text-center" style=""><article><img src="'+data.data[21].image.original.url+'" /></article></a>');               
        $("#pinterest_23").append(' <a href="'+data.data[22].url+'" class="articleOne text-center" style=""><article><img src="'+data.data[22].image.original.url+'" /></article></a>');               
        $("#pinterest_24").append(' <a href="'+data.data[23].url+'" class="articleOne text-center" style=""><article><img src="'+data.data[23].image.original.url+'" /></article></a>');               
        $("#pinterest_25").append(' <a href="'+data.data[24].url+'" class="articleOne text-center" style=""><article><img src="'+data.data[24].image.original.url+'" /></article></a>');               
        $("#pinterest_26").append(' <a href="'+data.data[25].url+'" class="articleOne text-center" style=""><article><img src="'+data.data[25].image.original.url+'" /></article></a>');               
        $("#pinterest_27").append(' <a href="'+data.data[26].url+'" class="articleOne text-center" style=""><article><img src="'+data.data[26].image.original.url+'" /></article></a>');               
        $("#pinterest_28").append(' <a href="'+data.data[27].url+'" class="articleOne text-center" style=""><article><img src="'+data.data[27].image.original.url+'" /></article></a>');               
        $("#pinterest_29").append(' <a href="'+data.data[28].url+'" class="articleOne text-center" style=""><article><img src="'+data.data[28].image.original.url+'" /></article></a>');               
        $("#pinterest_30").append(' <a href="'+data.data[29].url+'" class="articleOne text-center" style=""><article><img src="'+data.data[29].image.original.url+'" /></article></a>');               
        $("#pinterest_31").append(' <a href="'+data.data[30].url+'" class="articleOne text-center" style=""><article><img src="'+data.data[30].image.original.url+'" /></article></a>');               
        $("#pinterest_32").append(' <a href="'+data.data[31].url+'" class="articleOne text-center" style=""><article><img src="'+data.data[31].image.original.url+'" /></article></a>');               
        $("#pinterest_33").append(' <a href="'+data.data[32].url+'" class="articleOne text-center" style=""><article><img src="'+data.data[32].image.original.url+'" /></article></a>');               
        $("#pinterest_34").append(' <a href="'+data.data[33].url+'" class="articleOne text-center" style=""><article><img src="'+data.data[33].image.original.url+'" /></article></a>');               
        $("#pinterest_35").append(' <a href="'+data.data[34].url+'" class="articleOne text-center" style=""><article><img src="'+data.data[34].image.original.url+'" /></article></a>');               
        $("#pinterest_36").append(' <a href="'+data.data[35].url+'" class="articleOne text-center" style=""><article><img src="'+data.data[35].image.original.url+'" /></article></a>');               
        $("#pinterest_37").append(' <a href="'+data.data[36].url+'" class="articleOne text-center" style=""><article><img src="'+data.data[36].image.original.url+'" /></article></a>');               
        $("#pinterest_38").append(' <a href="'+data.data[37].url+'" class="articleOne text-center" style=""><article><img src="'+data.data[37].image.original.url+'" /></article></a>');               
        $("#pinterest_39").append(' <a href="'+data.data[38].url+'" class="articleOne text-center" style=""><article><img src="'+data.data[38].image.original.url+'" /></article></a>');               
        $("#pinterest_40").append(' <a href="'+data.data[39].url+'" class="articleOne text-center" style=""><article><img src="'+data.data[39].image.original.url+'" /></article></a>');               
     */reinitializeMasonry();
      }
    }
  });
}
function pinterest_tm(url) {
  $.ajax({
    type: "GET",
    dataType: "jsonp",
    cache: false,
    url: url,
    success: function(data) 
    {                             

      console.log(data);/*Object.keys(data).length/3*/
      for(var i=0;i<1; i++)
      {        
        $("#trademarks_1").append(' <a href="'+data.data[0].url+'" class="articleOne text-center" style=""><article><img src="'+data.data[0].image.original.url+'" /></article></a>');               
        $("#trademarks_2").append(' <a href="'+data.data[1].url+'" class="articleOne text-center" style=""><article><img src="'+data.data[1].image.original.url+'" /></article></a>');               
        $("#trademarks_3").append(' <a href="'+data.data[2].url+'" class="articleOne text-center" style=""><article><img src="'+data.data[2].image.original.url+'" /></article></a>');               

      }
    }
  });
}
function pinterest_co(url) {
  $.ajax({
    type: "GET",
    dataType: "jsonp",
    cache: false,
    url: url,
    success: function(data) 
    {                             

      console.log(data);/*Object.keys(data).length/3*/
      for(var i=0;i<1; i++)
      {        
        $("#code").append(' <a href="'+data.data[0].url+'" class="articleTwo text-center" style="background-image: url('+data.data[0].image.original.url+');"><article><p><i class="fa fa-code fa-3x"></i></p><h3 title="Code">Code</h3><p>PHP Wordpress, Python Django, MySQL, C++, JavaScript, Jquery, Ajax, CSS, HTML</p></article></a>');               

      }
    }
  });
}
function tumblr(url) {
  $.ajax({
    type: "GET",
    dataType: "jsonp",
    cache: false,
    url: url,
    success: function(data) 
    {                             
      console.log(data);/*Object.keys(data).length/3*/

      for(var i=0;i<1; i++)
      {
        $("#tumblr").append(' <a href="'+data.posts.id[0].url+'" class="articleOne" style="background-image: url('+data.data[0].post_image_url+');"><article><p><i class="fa fa-tumblr fa-3x"></i></p><h3 title="Code">Tumblr</h3><p>Tumble along, read my stories</p></article></a>');               


      }
    }
  });
}



$(document).ready(function(){

  $("#scroll-welcome").click(function (){
    $('html, body').animate({
      scrollTop: $("#services").offset().top
    }, 2000);
  });

  $(".toggle-search").click(function(){
    if($('#loginForm').css('display') == 'block' && $('#pushMenu').css('left') >= '0px'){

      $("#loginForm").slideToggle();
      $('#pushMenu').animate({
        left: "-287px"
      }, 200);

      $('#contentWrapper').animate({
        left: "0px"
      }, 200);

    }else if($('#pushMenu').css('left') >= '0px'){

      $('#pushMenu').animate({
        left: "-287px"
      }, 200);

      $('#contentWrapper').animate({
        left: "0px"
      }, 200);

    }else if($('#loginForm').css('display') == 'block'){

      $("#loginForm").slideToggle();
    }

    $("#searchForm").slideToggle();
  });
  $(".toggle-login").click(function(){

    if($('#searchForm').css('display') == 'block' && $('#pushMenu').css('left') >= '0px'){

      $("#searchForm").slideToggle();
      $('#pushMenu').animate({
        left: "-287px"
      }, 200);

      $('#contentWrapper').animate({
        left: "0px"
      }, 200);

    }else if($('#pushMenu').css('left') >= '0px'){

      $('#pushMenu').animate({
        left: "-287px"
      }, 200);

      $('#contentWrapper').animate({
        left: "0px"
      }, 200);

    }else if($('#searchForm').css('display') == 'block'){

      $("#searchForm").slideToggle();
    }


    $("#loginForm").slideToggle();
  });
  $(".toggle-pw-recovery").click(function(){
    if($('#login').css('display') == 'block'){

      document.getElementById("login").style.display = "none";
      document.getElementById("password-recovery").style.display = "block";

    }else if($('#password-recovery').css('display') == 'block'){

      document.getElementById("password-recovery").style.display = "none";
      document.getElementById("login").style.display = "block";

    }

  });
  /*------------------------------------left side push menu--------------------------------------*/
  $('.toggle-pushMenu').click(function() {
    if($('#pushMenu').css('left') < '0px'){
      $('#pushMenu').animate({
        left: "0px"
      }, 200);
      $('#contentWrapper').animate({
        left: "287px"
      }, 200);
    }else{
      $('#pushMenu').animate({
        left: "-287px"
      }, 200);
      $('#contentWrapper').animate({
        left: "0px"
      }, 200);
    }
  });

});




